export default __webpack_public_path__ + "static/media/hu.64fe83a2.svg";